import { Component, Input } from '@angular/core';

import { DateRangeOption } from '../../../../../../../../models/membership';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { dateStringFromISO8601 } from '../../../../../../../../utils';


@Component({
  selector: 'app-add-date-range-option-modal',
  templateUrl: './add-date-range-option-modal.component.html',
  styleUrls: ['./add-date-range-option-modal.component.css']
})
export class AddDateRangeOptionModalComponent {
  @Input() completedCallback: (result: DateRangeOption) => undefined;

  public dateRangeOption: DateRangeOption = {
    start_date: '',
    end_date: ''
  }

  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  public errorMessage(): string | null {
    const datesReversed = (
      !!this.dateRangeOption.start_date &&
      !!this.dateRangeOption.end_date &&
      (this.dateRangeOption.start_date >= this.dateRangeOption.end_date)
    );
    if (datesReversed) {
      return 'Please ensure the end date is later than the start date.';
    }

    return null;
  }

  public inputsValid() {
    return (
      !!this.dateRangeOption.start_date &&
      !!this.dateRangeOption.end_date &&
      (this.errorMessage() === null)
    );
  }

  public handleSubmit() {
    this.completedCallback(this.dateRangeOption);

    this.activeModal.close();
  }
}
